import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';
import { lastValueFrom } from 'rxjs';

const baseRoute = '/clients';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
  async getFullName(type: string, identity: string) {
    try {
      const url = this.routesCrud.list + '/info';
      const httpResponse = await lastValueFrom(
        this.request({
          method: 'GET',
          url,
          params: { type, identity },
          clearCache: true
        })
      );
      return this.refactorResponse(httpResponse);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }
}
